import AlertModal from '@/components/modals/AlertModal.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { ShowAlertPayload, ShowPromptPayload } from '@/helpers/vfm/types';

const showAlert = async (payload: ShowAlertPayload) => {
	await VFMHelper.ensureVfmCss();

	const { additionalContexts = [] } = payload;

	let clickResult: number | null = null;
	const { header, subHeader = '', message = '', buttons, options = {} } = payload;

	const { promise, dismiss } = VFMHelper.open({
		type: 'alert',
		onOpened: () => {
			TrackingHelper.trackEvent(
				'userinteraction',
				{
					action: 'alert_opened',
					nonInteraction: true,
				},
				additionalContexts
			);
		},
		onClosed: () => {
			TrackingHelper.trackEvent(
				'userinteraction',
				{
					action: 'alert_closed',
					label: clickResult + '',
				},
				additionalContexts
			);
		},
		slotComponent: AlertModal,
		slotProps: {
			header,
			subHeader,
			message,
			buttons: buttons.map((button, index) => {
				return {
					text: button,
					cssClass: `alert-message__button-${index}`,
					handler: () => {
						clickResult = index;
						dismiss(index);
					},
				};
			}),
			...options,
		},
	});

	return promise;
};

const promptAlert = async (payload: ShowPromptPayload) => {
	await VFMHelper.ensureVfmCss();

	let clickResult: number | null = null;
	const { header, subHeader = '', inputs, message = '', buttons, options = {} } = payload;

	const { promise, dismiss } = VFMHelper.open({
		type: 'alert',
		onOpened: () => {
			TrackingHelper.trackEvent('userinteraction', {
				action: 'alert_opened',
				nonInteraction: true,
			});
		},
		onClosed: () => {
			TrackingHelper.trackEvent('userinteraction', {
				action: 'alert_closed',
				label: clickResult + '',
			});
		},
		slotComponent: AlertModal,
		slotProps: {
			header,
			subHeader,
			inputs,
			message,
			buttons: buttons.map((button, index) => {
				return {
					...button,
					cssClass: `alert-message__button-${index}`,
					handler: (data: any) => {
						clickResult = index;
						if (button.handler) {
							let hasNotFilledAllInputs = false;
							// Check if user has filled all inputs, and if not, don't remove the prompt.
							Object.values(data).forEach(key => {
								if (key === '') {
									hasNotFilledAllInputs = true;
								}
							});
							if (!hasNotFilledAllInputs) {
								button?.handler(data);
								dismiss(index);
							}
						} else {
							dismiss(index);
						}
					},
				};
			}),
			...options,
		},
	});

	return promise;
};

export { promptAlert, showAlert };
